import { Flex, Page, Typography } from 'components';
import React, { ReactElement } from 'react';

const NotFoundView = (): ReactElement => (
  <Page>
    <Flex height="100vh" alignItems="center" justifyContent="center" bg="gray_100">
      <Typography type="type11" color="black50" upper>
        Página não encontrada
      </Typography>
    </Flex>
  </Page>
);

export default NotFoundView;
